module.exports = __webpack_public_path__ + "static/battle_07-a70f91b9293500d1dc1b9dbd5490bf28.jpg";